import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { MoreHorizontal } from "lucide-react";
import { usePopover } from "../ui";

/**
 * The app bar's overflow on narrow and medium layouts: the controls that sit in the bar on wide screens (space,
 * assistant, language, profile) in one panel, in the same order.
 */
export function MoreMenu({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const { open, toggle, ref } = usePopover<HTMLDivElement>();
  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        aria-haspopup="true"
        aria-expanded={open}
        onClick={toggle}
        className="grid h-[30px] w-[30px] place-items-center rounded-sm border border-neutral-200 bg-[var(--surface)] text-neutral-600 hover:border-neutral-700 aria-expanded:border-accent aria-expanded:text-accent touch:h-11 touch:w-11 dark:border-neutral-800 dark:text-neutral-300"
        aria-label={t("common.more")}
        title={t("common.more")}
        data-testid="more-menu"
      >
        <MoreHorizontal size={16} aria-hidden />
      </button>
      {open && (
        <div
          className="absolute right-0 top-10 z-40 flex w-[min(20rem,calc(100vw-1rem))] flex-col items-start gap-3 rounded-md border border-neutral-200 bg-[var(--surface)] p-3 text-sm shadow-[var(--shadow-md)] dark:border-neutral-700"
          data-testid="more-panel"
        >
          {children}
        </div>
      )}
    </div>
  );
}
